import {
  SchemaConstants
} from '@applyonline/shared/types'

export const APPLY_MECH_WARRANTY_CONSTANTS: SchemaConstants & { HousingToIncomeRatioThreshold: number } = {
  IncludeCoapplicant: true,
  FinanceFeeRateForRegular: 0.06,
  MaxRate: 29.99,
  BaseMinTerm: 12,
  BaseMaxTerm: 72,
  CorrectedMaxTerm: 60,
  MaxTermUnderAmountThreshold: 60,
  LongTerm: 84,
  MinLoanAmount: 1000,
  MaxLoanAmount: 15000,
  LargeLoanAmount: 10000,
  AmountThresholdForLowerTerm: 3000,
  MinIncomes: 21000,
  MaxIncomes: 1000000,
  HousingToIncomeRatioThreshold: 0.35,
}